<div class="data-status-container">
  <button mat-icon-button color="primary" (click)="refresh.emit()"
    [disabled]="isLoading || (connectionStatus$ | async) === 'offline'">
    <mat-icon>refresh</mat-icon>
  </button>
  <div *ngIf="
      isLoading || (dataAgeMsg$ | async) || (connectionStatus$ | async);
      else placeholder
    " class="text-xs data-age">
    <span *ngIf="isLoading" @fadeIn>Refreshing...</span>
    <span *ngIf="(connectionStatus$ | async) === 'offline'" @fadeIn>[Offline]
    </span>
    <span *ngIf="!isLoading && (dataAgeMsg$ | async) as dataAgeMsg" @fadeIn>{{
      dataAgeMsg
      }}</span>
  </div>
</div>

<ng-template #placeholder>
  <div>&nbsp;</div>
</ng-template>